import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const searchDateVisitsAll = async (site_id: any, registration: any) => {
  const result = await fetch(
    `${REACT_APP_VMS_BASE_URL}/visits/sites/${site_id}/all/search?vehicle=${registration}`
  );
  const visits = await result.json();
  return visits;
};

export default searchDateVisitsAll;
